import type { PropsWithChildren } from "react";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Dropdown } from "@circle-react-shared/uikit/Dropdown";
import { useSelectedBlock } from "../Hooks/useBuilderStore";
import { useSelectedBlockActions } from "../Hooks/useSelectedBlockActions";

export interface SidebarActionsProps {}

export const SidebarActions = ({
  children,
}: PropsWithChildren<SidebarActionsProps>) => {
  const { selectedBlock } = useSelectedBlock();
  const options = useSelectedBlockActions();

  const label = t("builder_ui.editor.actions");

  if (!selectedBlock) {
    return null;
  }

  return (
    <Dropdown
      direction="bottom-end"
      menuWrapperClassName="!mt-2"
      buttonClassName="flex items-center h-6 w-6 flex justify-center !rounded-full transition-colors duration-200 hover:bg-tertiary focus-visible:outline-secondary focus-visible:rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:bg-tertiary"
      button={
        <TippyV2 content={label} className="flex items-center p-1">
          <Icon
            className="text-default !h-6 !w-6"
            type="20-menu-dots-horizontal"
            size={20}
            aria-label={label}
          />
        </TippyV2>
      }
      options={options}
      dataTestId="builder-ui-sidebar-actions-dropdown"
    >
      {children}
    </Dropdown>
  );
};
